<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Libellé <span class="text-danger">*</span></label>
          <input type="text" class="form-control" formControlName="libelle" placeholder="Libellé de la ligne">
          <span *ngIf="submit && f.libelle.errors?.required" class="text-danger">Le libellé est obligatoire</span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Type <span class="text-danger">*</span></label>
          <select class="form-control" formControlName="type">
            <option *ngFor="let t of types" [value]="t.value">{{ t.label }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Montant prévu <span class="text-danger">*</span></label>
          <input type="number" class="form-control" formControlName="montant">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Montant réalisé</label>
          <input type="number" class="form-control" formControlName="montantRealise">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Compte OHADA</label>
          <input type="text" class="form-control" formControlName="compteOHADA" placeholder="Ex: 6132">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Catégorie</label>
          <input type="text" class="form-control" formControlName="categorie" placeholder="Catégorie">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Sous-catégorie</label>
          <input type="text" class="form-control" formControlName="sousCategorie" placeholder="Sous-catégorie">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group form-check mt-4">
          <input type="checkbox" class="form-check-input" formControlName="estRecuperable" id="estRecuperable">
          <label class="form-check-label" for="estRecuperable">Charge récupérable</label>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Description</label>
          <textarea class="form-control" formControlName="description" rows="2"></textarea>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onClose()">Fermer</button>
  <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="onSubmit()">Enregistrer</button>
</div>
